import { useInteraction } from '@/common/hooks/useInteraction';

interface Params {
  id: string;
  type: string;
}

export function useOfferExperience({ id, type }: Params) {
  const { data, isLoading } = useInteraction(id, type, type !== 'listing');

  const offerExperience =
    data && 'offerExperience' in data ? data.offerExperience : undefined;

  return {
    offerExperience,
    isLOMOfferExperience: offerExperience === 'lom',
    isLoading,
  } as const;
}
